/* NGA — Story video
   Swaps the poster for a real player on click, so nothing streams until it is
   actually wanted. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  // An always-running film still should not stream while it is off screen.
  function autoplay(root) {
    var videos = root.querySelectorAll('[data-nga-story-auto]');
    if (!videos.length || reduce.matches || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            if (v.preload === 'none') v.preload = 'auto';
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      },
      { rootMargin: '15% 0px', threshold: 0.2 }
    );

    Array.prototype.forEach.call(videos, function (v) { io.observe(v); });
  }

  function init(root) {
    autoplay(root);

    root.querySelectorAll('[data-nga-story-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.dataset.src;
        if (!src) return;

        var video = document.createElement('video');
        video.className = 'nga-sv__video';
        video.src = src;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');

        var poster = btn.querySelector('img');
        if (poster) video.poster = poster.currentSrc || poster.src;

        btn.replaceWith(video);
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-nga-story-video]:not([data-done])').forEach(function (root) {
      root.setAttribute('data-done', '');
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
